'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _d2 = require('d3');

var d3 = _interopRequireWildcard(_d2);

var _lodash = require('lodash.sortby');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactMeasure = require('react-measure');

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getTraitCategoryRanges = function getTraitCategoryRanges(assocs, x) {
  return assocs.reduce(function (acc, assoc) {
    if (acc.length === 0 || acc[acc.length - 1].traitCategory !== assoc.traitCategory) {
      acc.push({
        traitCategory: assoc.traitCategory,
        start: x(assoc.studyId),
        end: x(assoc.studyId)
      });
      return acc;
    }

    var prev = acc[acc.length - 1];
    prev.start = Math.min(prev.start, x(assoc.studyId));
    prev.end = Math.max(prev.end, x(assoc.studyId));
    return acc;
  }, []);
};

var orient = {
  top: function top(text) {
    return text.attr('text-anchor', 'middle').attr('y', -6);
  },
  right: function right(text) {
    return text.attr('text-anchor', 'start').attr('dy', '0.35em').attr('x', 6);
  },
  bottom: function bottom(text) {
    return text.attr('text-anchor', 'middle').attr('dy', '0.71em').attr('y', 6);
  },
  left: function left(text) {
    return text.attr('text-anchor', 'end').attr('dy', '0.35em').attr('x', -6);
  }
};

var PheWAS = function (_Component) {
  _inherits(PheWAS, _Component);

  function PheWAS(props) {
    _classCallCheck(this, PheWAS);

    var _this = _possibleConstructorReturn(this, (PheWAS.__proto__ || Object.getPrototypeOf(PheWAS)).call(this, props));

    _this.svgRef = _react2.default.createRef();
    _this.x = d3.scaleBand();
    _this.y = d3.scaleLinear();
    _this.colourScale = d3.scaleOrdinal();
    _this.categoryScale = d3.scaleOrdinal();
    _this.voronoi = d3.voronoi();
    return _this;
  }

  _createClass(PheWAS, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._render();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._render();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var measureRef = this.props.measureRef;

      var _dimensions2 = this._dimensions(),
          outerWidth = _dimensions2.outerWidth,
          outerHeight = _dimensions2.outerHeight;

      return _react2.default.createElement(
        'div',
        { ref: measureRef },
        _react2.default.createElement(
          'svg',
          {
            xmlns: 'http://www.w3.org/2000/svg',
            width: outerWidth,
            height: outerHeight,
            ref: function ref(node) {
              return _this2.svgRef = node;
            }
          },
          _react2.default.createElement('g', {
            transform: 'translate(' + _theme2.default.margin.left + ',' + _theme2.default.margin.phewasTop + ')'
          })
        )
      );
    }
  }, {
    key: '_dimensions',
    value: function _dimensions() {
      var contentRect = this.props.contentRect;
      var outerWidth = contentRect.bounds.width;

      var outerHeight = 440;
      return { outerWidth: outerWidth, outerHeight: outerHeight };
    }
  }, {
    key: '_render',
    value: function _render() {
      var x = this.x,
          y = this.y,
          colourScale = this.colourScale,
          categoryScale = this.categoryScale,
          voronoi = this.voronoi;
      var _props = this.props,
          associations = _props.associations,
          handleMouseover = _props.handleMouseover,
          significancePVal = _props.significancePVal;

      var _dimensions3 = this._dimensions(),
          outerWidth = _dimensions3.outerWidth,
          outerHeight = _dimensions3.outerHeight;

      if (!outerWidth || !outerHeight) {
        return;
      }

      var width = outerWidth - _theme2.default.margin.right - _theme2.default.margin.left;
      var height = outerHeight - _theme2.default.margin.top - _theme2.default.margin.phewasBottom;

      var assocs = (0, _lodash2.default)(associations, ['traitCategory']);

      var svg = d3.select(this.svgRef);
      var chart = svg.select('g');

      var significance = -Math.log10(significancePVal ? significancePVal : 0.05 / assocs.length);

      var _d3$extent = d3.extent(assocs, function (assoc) {
        return -Math.log10(assoc.pval);
      }),
          _d3$extent2 = _slicedToArray(_d3$extent, 2),
          minLogPval = _d3$extent2[0],
          maxLogPval = _d3$extent2[1];

      x.domain(assocs.map(function (assoc) {
        return assoc.studyId;
      })).range([0, width]);
      y.domain([Math.min(significance, minLogPval), Math.max(significance, maxLogPval)]).range([height, 0]);

      var polygons = voronoi.x(function (d) {
        return x(d.studyId);
      }).y(function (d) {
        return y(-Math.log10(d.pval));
      }).extent([[-1, -1], [width + 1, height + 1]]).polygons(assocs);

      var traitCategoryRanges = getTraitCategoryRanges(assocs, x);
      var traitPositions = traitCategoryRanges.map(function (range) {
        return (range.start + range.end) / 2;
      });
      var traitCategories = traitCategoryRanges.map(function (category) {
        return category.traitCategory;
      });
      categoryScale.domain(traitCategories).range(traitPositions);
      colourScale.domain(traitCategories).range(d3.schemeCategory10);

      var xAxis = d3.axisBottom(categoryScale);
      var yAxis = d3.axisLeft(y);

      this._renderLegend(svg, outerWidth);
      this._renderLogPValueAxis(chart, yAxis);
      this._renderStudiesAxis(chart, height, xAxis, colourScale);
      this._renderSignificanceLine(chart, y, width, significance);
      this._renderDataPoints(chart, assocs, colourScale, handleMouseover);
      this._renderTraitLabels(chart, polygons, x, y, significance);
    }
  }, {
    key: '_renderLegend',
    value: function _renderLegend(svg, width) {
      var g = svg.select('.legend');
      var rect = svg.select('.legend rect');

      if (g.empty()) {
        var trianglePath = d3.symbol().size(32).type(d3.symbolTriangle);

        g = svg.append('g').attr('class', 'legend').style('font', '12px sans-serif');
        rect = g.append('rect').attr('height', _theme2.default.legend.height).attr('fill', _theme2.default.legend.backgroundColor);

        g.append('path').attr('d', trianglePath).attr('fill', _theme2.default.axis.color).attr('transform', 'translate(100, 25)');

        g.append('text').attr('fill', _theme2.default.axis.color).attr('transform', 'translate(110 28)').text('Positive Beta');

        g.append('path').attr('d', trianglePath).attr('fill', _theme2.default.axis.color).attr('transform', 'translate(230, 22) rotate(180)');

        g.append('text').attr('fill', _theme2.default.axis.color).attr('transform', 'translate(240, 28)').text('Negative Beta');
      }

      rect.attr('width', width);
    }
  }, {
    key: '_renderStudiesAxis',
    value: function _renderStudiesAxis(chart, height, xAxis, colourScale) {
      var g = chart.select('.axis.axis--studies');
      if (g.empty()) {
        g = chart.append('g').classed('axis axis--studies', true);
      }
      g.attr('transform', 'translate(0,' + height + ')').call(xAxis).selectAll('text').attr('transform', 'rotate(45)').attr('x', 0).attr('y', 0).attr('dx', '.4em').attr('dy', '1.5em').attr('fill', function (d) {
        return colourScale(d);
      }).style('text-anchor', 'start');
      g.selectAll('.domain, .tick line').attr('stroke', _theme2.default.axis.color);
    }
  }, {
    key: '_renderLogPValueAxis',
    value: function _renderLogPValueAxis(chart, yAxis) {
      var g = chart.select('.axis.axis--minus-log-pvalue');
      if (g.empty()) {
        g = chart.append('g').classed('axis axis--minus-log-pvalue', true);
      }
      g.call(yAxis);
      g.selectAll('.tick text').attr('fill', _theme2.default.axis.color);
      g.selectAll('.domain, .tick line').attr('stroke', _theme2.default.axis.color);

      var label = g.select('.axis-label.axis-label--minus-log-pvalue');

      if (label.empty()) {
        label = g.append('text').attr('class', 'axis-label axis-label--minus-log-pvalue').attr('transform', 'rotate(-90)').attr('font-size', 12).attr('dy', -40).attr('text-anchor', 'end').attr('fill', _theme2.default.axis.color).text('-log₁₀(p-value)');
      }
    }
  }, {
    key: '_renderSignificanceLine',
    value: function _renderSignificanceLine(chart, y, width, significance) {
      var significanceLine = chart.select('.significance');

      if (significanceLine.empty()) {
        significanceLine = chart.append('line').classed('significance', true);
      }

      significanceLine.attr('x1', 0).attr('y1', y(significance)).attr('x2', width).attr('y2', y(significance)).attr('stroke', _theme2.default.secondary);
    }
  }, {
    key: '_renderDataPoints',
    value: function _renderDataPoints(chart, assocs, colourScale, handleMouseover) {
      var x = this.x,
          y = this.y;

      var trianglePath = d3.symbol().size(32).type(d3.symbolTriangle);

      var dataPoints = chart.selectAll('path.point').data(assocs, function (assoc) {
        return assoc.studyId;
      });

      dataPoints.enter().append('path').attr('class', function (assoc) {
        return 'point loci-' + assoc.studyId;
      }).attr('fill', function (assoc) {
        return colourScale(assoc.traitCategory);
      }).attr('data-colour', function (assoc) {
        return colourScale(assoc.traitCategory);
      }).attr('d', trianglePath).merge(dataPoints).attr('transform', function (assoc) {
        var xPos = x(assoc.studyId);
        var yPos = y(-Math.log10(assoc.pval));
        var rotation = assoc.beta < 0 ? ',rotate(180)' : '';
        return 'translate(' + xPos + ',' + yPos + ')' + rotation;
      }).on('mouseover', handleMouseover);

      dataPoints.exit().remove();
    }
  }, {
    key: '_renderTraitLabels',
    value: function _renderTraitLabels(chart, polygons, x, y, significance) {
      var g = d3.select('.trait-labels');

      if (g.empty()) {
        g = chart.append('g').attr('class', 'trait-labels').style('font', '10px sans-serif');
      }

      var traitLabels = g.selectAll('text').data(polygons.filter(function (d) {
        return d3.polygonArea(d) > 2000 && -Math.log10(d.data.pval) > significance;
      }));

      traitLabels.enter().append('text').merge(traitLabels).each(function (d) {
        var _d3$polygonCentroid = d3.polygonCentroid(d),
            _d3$polygonCentroid2 = _slicedToArray(_d3$polygonCentroid, 2),
            cx = _d3$polygonCentroid2[0],
            cy = _d3$polygonCentroid2[1];

        var xPos = x(d.data.studyId);
        var yPos = y(-Math.log10(d.data.pval));
        // find angle between vector, going from the point that generates
        // the voronoi cell to the centroid of the cell, and the x axis
        var angle = Math.round(Math.atan2(cy - yPos, cx - xPos) / Math.PI * 2);
        d3.select(this).call(angle === 0 ? orient.right : angle === -1 ? orient.top : angle === 1 ? orient.bottom : orient.left);
      }).attr('fill', _theme2.default.axis.color).attr('transform', function (d) {
        var xPos = x(d.data.studyId);
        var yPos = y(-Math.log10(d.data.pval));
        return 'translate(' + xPos + ',' + yPos + ')';
      }).text(function (d) {
        var traitReported = d.data.traitReported;

        return traitReported.length <= 30 ? traitReported : traitReported.slice(0, 30) + '...';
      });

      traitLabels.exit().remove();
    }
  }]);

  return PheWAS;
}(_react.Component);

PheWAS.defaultProps = {
  handleMouseover: function handleMouseover() {}
};

exports.default = (0, _reactMeasure.withContentRect)('bounds')(PheWAS);